<template>
  <div class="row">
    <div class="box row">
      <div class="full-page p-40">
        <div class="full-page-container">
          <div class="row">
            <div class="col text-center">
              <lottie
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
              ></lottie>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div
                v-if="
                  pageDetails.additionalNotes &&
                  pageDetails.additionalNotes.length > 0
                "
              >
                <h2 class="m-t-40">
                  {{ $t(`failure.${pageDetails.additionalNotes[0]}.title`) }}
                </h2>
                <p>
                  {{ $t(`failure.${pageDetails.additionalNotes[0]}.text`) }}
                </p>
              </div>
              <div
                v-if="
                  !pageDetails.additionalNotes ||
                  pageDetails.additionalNotes.length == 0
                "
              >
                <h2 class="m-t-40">{{ $t("failure.default.title") }}</h2>
                <p>{{ $t("failure.default.text") }}</p>
              </div>
            </div>
            <div class="col-sm-12 m-t-40 text-center" v-if="hostedCheckoutId">
              <button class="btn btn-cta failure" @click="tryAgain()">
                {{ $t("failure.btnText") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      v-if="merchantDetails.returnUrl"
      @click="backToMerchant()"
      class="btn btn-primary-icon-text back-to-shop-link"
    >
      <span
        aria-hidden="true"
        class="cm-icon cm-icon-previous"
        data-cm-icon="https://www.cm.com/en-gb/app/aurora/svg/previous.svg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          cm-icon-url="https://www.cm.com/en-gb/app/aurora/svg/previous.svg"
        >
          <path
            fill="#3C4859"
            fill-rule="evenodd"
            d="M14.00025,18.00025 C13.74425,18.00025 13.48825,17.90225 13.29325,17.70725 L8.29325,12.70725 C7.90225,12.31625 7.90225,11.68425 8.29325,11.29325 L13.29325,6.29325 C13.68425,5.90225 14.31625,5.90225 14.70725,6.29325 C15.09825,6.68425 15.09825,7.31625 14.70725,7.70725 L10.41425,12.00025 L14.70725,16.29325 C15.09825,16.68425 15.09825,17.31625 14.70725,17.70725 C14.51225,17.90225 14.25625,18.00025 14.00025,18.00025"
          ></path>
        </svg>
      </span>
      <span>{{ $t("btnBackToShop") }}</span>
    </button>
    <footer class="row page">
      <div class="col-sm-12 text-center">
        {{ $t("protectedBy") }}
        <a href="https://www.cm.com" target="_blank">CM.com</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../assets/animation/failure.json";
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentFailure",
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
    };
  },
  computed: {
    ...paymentNS.mapGetters([
      "merchantDetails",
      "pageDetails",
      "hostedCheckoutId",
    ]),
  },
  methods: {
    ...paymentNS.mapActions(["restart"]),
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    tryAgain() {
      this.restart();
    },
    backToMerchant() {
      window.location.href = this.merchantDetails.returnUrl;
    },
  },
};
</script>
